import { render, staticRenderFns } from "./SchedulePostSettings.vue?vue&type=template&id=351458ba&"
import script from "./SchedulePostSettings.vue?vue&type=script&lang=ts&"
export * from "./SchedulePostSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports